import { FC } from "react"
import styled from "styled-components"
import { iconSizeS, spacingXs } from "@rhumbix/rmbx_design_system_web"
import { IconName, getStyledIcon } from "../../../common/ts-utils"

interface IconHeaderProps {
    /** The AG-Grid column object, used to read headerName from the colDef. */
    column: { colDef: { headerName?: string } }
    /** The icon name to render alongside the header text. */
    iconName?: IconName
}

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacingXs};
    width: 100%;
`

const IconWrapper = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    width: ${iconSizeS};
    height: ${iconSizeS};
`

const ICON_STYLES = { width: iconSizeS, height: iconSizeS }

/**
 * A reusable AG-Grid header component that displays an icon alongside the column header text.
 * Pass the icon name via headerComponentParams.iconName in the column definition.
 */
const IconHeader: FC<IconHeaderProps> = ({ column, iconName }) => {
    return (
        <HeaderContainer>
            {iconName && <IconWrapper>{getStyledIcon(iconName, ICON_STYLES)}</IconWrapper>}
            <span>{column.colDef.headerName}</span>
        </HeaderContainer>
    )
}

export default IconHeader
